module.exports = __webpack_public_path__ + "img/ico-coach.3a132206.svg";